/**
 * Slope planning bands shared by the map, the legend and the terrain card.
 * Percent slope is rise over run; the backend reports one value per ~1 m cell
 * measured on a 3 m smoothed surface (see parcel_terrain.slope_bands).
 */
export const SLOPE_BANDS = [
  { key: 'flat', label: 'Flat', min: 0, max: 2, color: '#3f9d63', buildability: 'Easy to build, hard to drain' },
  { key: 'gentle', label: 'Gentle', min: 2, max: 5, color: '#9ad37f', buildability: 'Ideal' },
  { key: 'moderate', label: 'Moderate', min: 5, max: 8, color: '#e9d95c', buildability: 'Buildable with care' },
  { key: 'rolling', label: 'Rolling', min: 8, max: 12, color: '#f2a93b', buildability: 'Manageable, plan-specific' },
  { key: 'steep', label: 'Steep', min: 12, max: 20, color: '#e8663d', buildability: 'Custom-leaning, engineered' },
  { key: 'very_steep', label: 'Very steep', min: 20, max: 30, color: '#b91c1c', buildability: 'Custom only' },
  { key: 'hillside', label: 'Hillside', min: 30, max: null, color: '#5b1230', buildability: 'Generally excluded' },
];

export const MAX_SLOPE_OPTIONS = [5, 8, 12, 15, 20, 25, 30];
export const DEFAULT_MAX_SLOPE_PERCENT = 20;
export const TERRAIN_COLOR_MODES = [
  { value: 'elevation', label: 'Elevation' },
  { value: 'slope', label: 'Slope' },
];
export const STEEP_COLOR = '#dc2626';

export function slopeBandFor(percent) {
  if (!Number.isFinite(percent) || percent < 0) return null;
  return SLOPE_BANDS.find((b) => percent >= b.min && (b.max == null || percent < b.max)) || SLOPE_BANDS[SLOPE_BANDS.length - 1];
}

export function bandRangeLabel(band) {
  return band.max == null ? `${band.min}%+` : `${band.min}–${band.max}%`;
}

/** Fall across a 50 ft deep house for a band, in feet (slope × 50). */
export function bandFallLabel(band) {
  const lo = band.min * 0.5;
  return band.max == null ? `${lo}+ ft` : `${lo}–${band.max * 0.5} ft`;
}

/** Share (0–1) of sampled cells steeper than `threshold` percent; null without slope samples. */
export function steeperShare(samples, threshold) {
  if (!Array.isArray(samples) || !Number.isFinite(threshold)) return null;
  let total = 0;
  let over = 0;
  for (const smp of samples) {
    const s = smp?.[4];
    if (!Number.isFinite(s)) continue;
    total += 1;
    if (s > threshold) over += 1;
  }
  return total ? over / total : null;
}
